import { useEffect, useState } from 'react';

export function useCSSBodyClass(visible: boolean): void {
  // Used when multiple modals are on the screen. Because they are controling the same classname,
  // sometimes we have 'collision'.
  // If I open a modal at mount, modals underneath are gonna run their useEffect after the first one.
  // Modal one will add the modal-open class, but the others will remove it.
  // Modals should remove the classname only if they have been opened at least once.
  const [hasDisplayedModalOnce, setHasDisplayedModalOnce] = useState<boolean>(false);

  useEffect(() => {
    if (visible) {
      setHasDisplayedModalOnce(true);
    }
  }, [visible]);

  useEffect(() => {
    if (hasDisplayedModalOnce) {
      window.document.body.classList.toggle('modal-open', visible);
    }
    return (): void => {
      window.document.body.classList.remove('modal-open');
    };
  }, [visible, hasDisplayedModalOnce]);
}
